import { Component, OnInit } from '@angular/core';
import {DOCUMENT_TYPES, SPECIAL_RES_STRATEGIES, VALUE_TYPE} from "../../enums/enums";
import {paramsHelper} from "../../helpers/params-helper";
import {IDocument} from "../../interfaces/document.definition";
import {BusService} from "../../services/bus.service";
import {UI_TEXTS} from "../../enums/e-texts";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {GO_CATEGORIES} from "../../enums/e-game-objects";
import {CollectionService} from "../../services/collection.service";
import {JP} from "../../helpers/jp";
import {forEach} from "@angular/router/src/utils/collection";
import {WatchService} from "../../services/watch.service";

@Component({
  selector: 'app-game-event-page',
  templateUrl: './game-event-page.component.html',
  styles: []
})
export class GameEventPageComponent implements OnInit {

  VAL_TYPES = VALUE_TYPE;
  UI_TEXTS = UI_TEXTS;
  SPECIAL_RES_STRATEGIES = SPECIAL_RES_STRATEGIES;

  pageParams = paramsHelper.page()
    .setTitle("Игровые события");

  document:IDocument;
  resourcesList:IDocument[];

  collectionParams = paramsHelper.collection()
    .setDuplicateEnabled(false)
    .setDefaultListLabels()
    .setItemLabelQuery('codeName')
    .setObjectType(DOCUMENT_TYPES.GAME_EVENT);

  loadedEventsList:any[]=[];

  get upgrateAccelerateSettingsVisible(): boolean {
    return this._upgrateAccelerateSettingsVisible;
  }

  get animalRVSettingsVisible(): boolean {
    return this._animalRVSettingsVisible;
  }

  get marketRVSettingsVisible(): boolean {
    return this._marketRVSettingsVisible;
  }

  get campRVSettingsVisible(): boolean {
    return this._campRVSettingsVisible;
  }

  get zeppelinRVSettingsVisible(): boolean {
    return this._zeppelinRVSettingsVisible;
  }

  get resourceRVSettingsVisible(): boolean {
    return this._resourceRVSettingsVisible;
  }

  get townhallResourceRVSettingsVisible(): boolean {
    return this._townhallResourceRVSettingsVisible;
  }

  get energyRVSettingsVisible(): boolean {
    return this._energyRVSettingsVisible;
  }

  get smmrRVSettingsVisible(): boolean {
    return this._smmrRVSettingsVisible;
  }

  get complexGarbageRVSettingsVisible(): boolean {
    return this._complexGarbageRVSettingsVisible;
  }

  get additionalQuestRewardSettingsVisible(): boolean {
    return this._additionalQuestRewardSettingsVisible;
  }

  get attributesVisible(): boolean {
    return this._attributesVisible;
  }

  private  _upgrateAccelerateSettingsVisible:boolean = true;
  private  _marketRVSettingsVisible:boolean = true;
  private  _animalRVSettingsVisible:boolean = true;
  private  _campRVSettingsVisible:boolean = true;
  private  _zeppelinRVSettingsVisible:boolean = true;
  private  _resourceRVSettingsVisible:boolean = true;
  private  _townhallResourceRVSettingsVisible:boolean = true;
  private  _energyRVSettingsVisible:boolean = true;
  private  _smmrRVSettingsVisible:boolean = true;
  private  _complexGarbageRVSettingsVisible:boolean = true;
  private  _additionalQuestRewardSettingsVisible:boolean = true;
  private  _attributesVisible:boolean = true;

  constructor(private busService:BusService,
              private collectionService:CollectionService,
              private watchService:WatchService) { }

  ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(e => this.updateDocument(e.document as IDocument));
    this.loadResourcesList();
    this.loadEventsList();
  }

  onToggleAccelerateSettingsClick()
  {
    this._upgrateAccelerateSettingsVisible = !this._upgrateAccelerateSettingsVisible;
  }

  onToggleAnimalRVSettingsClick()
  {
    this._animalRVSettingsVisible = !this._animalRVSettingsVisible;
  }

  onToggleMarketRVSettingsClick()
  {
    this._marketRVSettingsVisible = !this._marketRVSettingsVisible;
  }

  onToggleCampRVSettingsClick()
  {
    this._campRVSettingsVisible = !this._campRVSettingsVisible;
  }

  onToggleZeppelinRVSettingsClick()
  {
    this._zeppelinRVSettingsVisible = !this._zeppelinRVSettingsVisible;
  }

  onToggleResourceRVSettingsClick()
  {
    this._resourceRVSettingsVisible = !this._resourceRVSettingsVisible;
  }

  onToggleTownhallResourceRVSettingsClick()
  {
    this._townhallResourceRVSettingsVisible = !this._townhallResourceRVSettingsVisible;
  }

  onToggleEnergyRVSettingsClick()
  {
    this._energyRVSettingsVisible = !this._energyRVSettingsVisible;
  }

  onToggleSmmrRVSettingsClick()
  {
    this._smmrRVSettingsVisible = !this._smmrRVSettingsVisible;
  }

  onToggleComplexGarbageRVSettingsClick()
  {
    this._complexGarbageRVSettingsVisible = !this._complexGarbageRVSettingsVisible;
  }

  onToggleAdditionalQuestRewardSettings()
  {
    this._additionalQuestRewardSettingsVisible = !this._additionalQuestRewardSettingsVisible;
  }

  onToggleAttributesClick()
  {
    this._attributesVisible = !this._attributesVisible;
  }

  onHasEnergyUpdate(val:boolean)
  {
    if (!val)
    {
      JP.remove(this.document,"/attributes/energyResourceId");
    }
  }

  onResStrategyChange(e)
  {
    let config = JSON.parse(JSON.stringify(this.SPECIAL_RES_STRATEGIES.find(item => item.algorithm == JP.get(this.document, "/attributes/specialResStrategy/algorithm")).config));
    JP.set(this.document, "/attributes/specialResStrategy/config", config);
  }

  onParentEvtChange()
  {
    this.watchService.notify();
  }

  private  loadResourcesList(){
    const search = paramsHelper
      .search()
      .addParam("category", SEARCH_PROP_TYPES.ENUM_MULTI, [GO_CATEGORIES.STUFF])
      .json;

    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.GO)
      .setNavParams(0, 9999)
      .setSearchParams(search);

    this.collectionService.loadChunkCached(params)
      .subscribe(
        r => {
          this.resourcesList = r.documents;
        });
  }

  private loadEventsList(){
    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setSearchParams(paramsHelper.search()
        .addParam("_type", SEARCH_PROP_TYPES.STRING,
          DOCUMENT_TYPES.GAME_EVENT).json
      )
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .subscribe(r => {
        this.loadedEventsList = r.documents;
        this.loadedEventsList.sort(this.sortByName);
      });
  }

  private updateDocument(document:IDocument){
    this.document = document;
  }

  private sortByName(a, b):number
  {
    if (a.name > b.name)
    {
      return 1;
    }
    else if (a.name < b.name)
    {
      return -1;
    }
    return 0;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/game-event-page/game-event-page.component.ts